<template>
  <span class="tooltip-help-container ml-25">
    <feather-icon
      v-b-tooltip.hover.v-primary="text"
      icon="HelpCircleIcon"
      size="15"
      class="cursor-pointer text-primary tooltip-help-icon"
    />
  </span>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'

export default {
  name: 'TooltipHelp',
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
.tooltip-help-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  vertical-align: middle;

  // Radiating rays/ripple effect on hover
  &::after {
    content: '';
    position: absolute;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: transparent;
    border: 2px solid rgba(115, 103, 240, 0.8);
    box-shadow: 0 0 8px rgba(115, 103, 240, 0.6);
    opacity: 0;
    pointer-events: none;
    transform: scale(0.8);
    transition: all 0.3s ease;
    box-sizing: border-box;
  }

  &:hover::after {
    animation: emit-rays-radial 1.2s infinite cubic-bezier(0.1, 0.8, 0.3, 1);
  }
}

.tooltip-help-icon {
  transition: all 0.3s ease;
  display: block;

  &:hover {
    transform: scale(1.2);
    color: #5a4feb !important; /* Vibrant primary */
    filter: drop-shadow(0 0 4px rgba(115, 103, 240, 0.8));
  }
}

@keyframes emit-rays-radial {
  0% {
    transform: scale(0.8);
    opacity: 0.8;
    box-shadow: 0 0 0 0 rgba(115, 103, 240, 0.5),
                0 0 0 0 rgba(115, 103, 240, 0.3);
  }
  100% {
    transform: scale(2.8);
    opacity: 0;
    box-shadow: 0 0 10px 10px rgba(115, 103, 240, 0),
                0 0 20px 20px rgba(115, 103, 240, 0);
  }
}
</style>
